<template>
  <el-form-item :label="title">
    <el-autocomplete
      v-model="value"
      :placeholder="placeholder"
      :autofocus="focus"
      :style="{ width: width + 'px' }"
      :fetch-suggestions="handleQuery"
      @select="handleSelect"
      :clearable="true"
    ></el-autocomplete>
  </el-form-item>
</template>

<script>
import { parse, save } from '../providers/store-parser'

export default {
  name: 'InputTextWithSuggestions',
  props: {
    title: {
      type: String,
      required: true
    },
    query: {
      type: Function,
      required: true
    },
    getter: {
      type: String,
      required: true
    },
    setter: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      default: ''
    },
    focus: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 145
    }
  },
  computed: {
    value: {
      get () {
        return parse(this.getter)
      },
      set (val) {
        save(this.setter, val)
      }
    }
  },
  methods: {
    async handleQuery (queryString, cb) {
      if (queryString !== '') {
        const data = (await this.query(queryString))
        cb(data)
      }
    },
    handleSelect () {
      // TODO
    }
  }
  // watch: {
  //   manual: function(val) {
  //     this.handler.call(this.provider, val)
  //   }
  // },
  // inject: ['provider']
}
</script>
